document.addEventListener("DOMContentLoaded", () => {
    const track = document.querySelector('.logo-track');
    const slider = document.querySelector('.logo-slider');
    const speed = 80; // Hastighet i px per sekund
    let lastTime = 0; // För att hålla reda på tid
    let offset = 0; // Initial offset för rörelsen
    let isPaused = false; // Flagga för att pausa eller inte
    let isDragging = false; // För att hålla reda på om användaren drar
    let startX = 0; // Startposition när dragningen börjar
    let scrollStart = 0; // Startpositionen för tracken vid dragning

    // Förhindra att länkar klickas under dragning
    function preventLinkClick(e) {
        if (isDragging) {
            e.preventDefault();
        }
    }

    function scrollLogos(timestamp) {
        if (isPaused || isDragging) {
            // Om pausad eller dragning pågår, stoppa uppdateringen av rörelsen
            requestAnimationFrame(scrollLogos);
            return;
        }

        // Beräkna tidsskillnad mellan frames
        const deltaTime = timestamp - lastTime;
        lastTime = timestamp;

        // Räkna ut hur mycket vi ska röra oss denna gång baserat på 150px per sekund
        const distance = (speed * deltaTime) / 1000; // dividera med 1000 för att få rätt värde per sekund

        // Flytta tracken med den beräknade distansen
        offset -= distance;

        // När vi har rullat hela bredden, sätt tillbaka till startposition
        if (offset <= -track.scrollWidth) {
            offset = 0;
        }

        // Använd CSS transform för att flytta tracken
        track.style.transform = `translateX(${offset}px)`;

        // Anropa nästa frame
        requestAnimationFrame(scrollLogos);
    }

    // Starta scrollingen
    requestAnimationFrame(scrollLogos);

    // Lägg till hover-effekt för att pausa och återuppta
    slider.addEventListener('mouseenter', () => {
        isPaused = true; // Pausa scrollningen när musen går över
    });

    slider.addEventListener('mouseleave', () => {
        isPaused = false; // Återuppta scrollningen när musen lämnar
        // Starta om animationen från den nuvarande positionen (offset)
        lastTime = performance.now(); // Sätt tillbaka tiden till nuvarande
        requestAnimationFrame(scrollLogos); // Börja om animationen med ny starttid
    });

    // Hantera dragning (mus)
    slider.addEventListener('mousedown', (e) => {
        e.preventDefault(); // Förhindra textmarkering eller andra oönskade beteenden
        isDragging = true;
        startX = e.clientX; // Spara musens startposition
        scrollStart = offset; // Spara den nuvarande scrollpositionen
    });

    // Hantera dragningens rörelse (mus)
    slider.addEventListener('mousemove', (e) => {
        if (!isDragging) return; // Om vi inte drar, gör inget

        const dx = e.clientX - startX; // Beräkna hur långt vi har dragit
        offset = scrollStart + dx; // Invertera rörelsen så vi drar åt motsatt håll

        // Begränsa positionen så att den inte går för långt
        if (offset > 0) {
            offset = 0; // Stoppa om vi är för långt till höger
        }

        // Uppdatera positionen för tracken
        track.style.transform = `translateX(${offset}px)`;
    });

    // Släpp dragningen (mus)
    slider.addEventListener('mouseup', () => {
        isDragging = false;
    });

    // Avbryt dragning om musen lämnar containern
    slider.addEventListener('mouseleave', () => {
        isDragging = false; // Avbryt dragning om musen lämnar
    });

    // Förhindrar att länkar klickas när vi drar (mus)
    const links = track.querySelectorAll('a');
    links.forEach(link => {
        link.addEventListener('click', (e) => {
            if (isDragging) {
                e.preventDefault(); // Förhindra klick under dragning
            }
        });
    });

    // För touchskärmar
    slider.addEventListener('touchstart', (e) => {
        e.preventDefault();
        isDragging = true;
        startX = e.touches[0].clientX; // Första pekpunktens X-position
        scrollStart = offset; // Spara den nuvarande scrollpositionen
    });

    slider.addEventListener('touchmove', (e) => {
        if (!isDragging) return;

        const dx = e.touches[0].clientX - startX; // Beräkna hur långt vi har dragit
        offset = scrollStart + dx; // Invertera rörelsen så vi drar åt motsatt håll

        if (offset > 0) {
            offset = 0;
        }

        track.style.transform = `translateX(${offset}px)`;
    });

    slider.addEventListener('touchend', () => {
        isDragging = false;
    });

    // Förhindrar att länkar klickas när vi drar (touch)
    links.forEach(link => {
        link.addEventListener('click', (e) => {
            if (isDragging) {
                e.preventDefault(); // Förhindra klick under dragning
            }
        });
    });
});
